import request from "@/utils/http/requset";

const merchantApi = {
  getMerchant(data) {
    return request({
      url: "/manage/merchant/remote",
      method: "post",
      ContentType: "application/json;charset=UTF-8",
      data: data
    });
  },

  getChannel(data) {
    return request({
      url: "/manage/payAccount/channels",
      method: "post",
      ContentType: "application/json;charset=UTF-8",
      data: data
    });
  },
  getAccountType(data) {
    return request({
      url: "/manage/accountType/search",
      method: "post",
      ContentType: "application/json;charset=UTF-8",
      data: data
    });
  },
  managePayPollingSearch(data) {
    return request({
      url: "/manage/payPolling/search",
      method: "post",
      ContentType: "application/json;charset=UTF-8",
      data: data
    });
  },
  managePayPollingUpdate(data) {
    return request({
      url: "/manage/payPolling/update",
      method: "post",
      ContentType: "application/json;charset=UTF-8",
      data: data
    });
  },
  managePayPollingAdd(data) {
    return request({
      url: "/manage/payPolling/create",
      method: "post",
      ContentType: "application/json;charset=UTF-8",
      data: data
    });
  },
  managePayPollingInitUpdate(data) {
    return request({
      url: "/manage/pollingInit/update",
      method: "post",
      ContentType: "application/json;charset=UTF-8",
      data: data
    });
  },
  managePayPollingLogSearch(data) {
    return request({
      url: "/manage/payPollingLog/search",
      method: "post",
      ContentType: "application/json;charset=UTF-8",
      data: data
    });
  },
  managePayPollingUpdate(data) {
    return request({
      url: "/manage/payPolling/update",
      method: "post",
      ContentType: "application/json;charset=UTF-8",
      data: data
    });
  },
};
export default merchantApi;
